import { Product } from '@/modules/products/types';
import { ProductTypes } from '@/utils/enums';

export const mapperProductsBuilderCustom = (data: Product[]) => {
  const types: Record<number, any>[] = [];
  const lines: Record<number, any> = {};
  const productsOriginal: any = {};
  const products: Record<number, any> = {};

  data.forEach((product: Product & { lineId?: number }) => {
    const category = product.categories[0];
    const line = product.lines[0];
    productsOriginal[product.id] = product;
    if (!lines[line.id]) {
      lines[line.id] = line;
    }
    if (category?.id === ProductTypes.TYPES_BOWL) {
      const newProduct = { ...product };
      newProduct.id = product.id;
      newProduct.lineId = line.id;
      types[newProduct.id] = { ...newProduct };
    } else if (!products[line.id]) {
      products[line.id] = {
        [category.id]: {
          ...category,
          products: [product],
        },
      };
    } else if (!products[line.id][category.id]) {
      products[line.id][category.id] = {
        ...category,
        products: [product],
      };
    } else {
      products[line.id][category.id].products.push(product);
    }
  });
  return { types, lines, products, productsOriginal };
};
